import { useLocation } from 'react-router-dom';
import { Title } from '../common/Title';
import { Link } from '../common/Link';

export const Header: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 flex justify-between p-8 z-20">
      <Title />
      <nav
        className="opacity-0 animate-fade-in text-black"
        style={{ animationDelay: '500ms', animationFillMode: 'forwards' }}
      >
        <Link href={pathname === '/about' ? '/' : '/about'} size="lg">
          {pathname === '/about' ? 'Work' : 'About'}
        </Link>
      </nav>
    </header>
  );
};
